module.exports = "fragment ColorFragment on Color {\n  __typename\n  red\n  green\n  blue\n}\n"